import React from 'react'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import { forgotInitialValues, forgotPasswordSchema } from 'constants/SignIn'
import { forgetUserPassword } from 'containers/sigin-in/Api'
import Logo from 'assets/images/login/logo.svg'
import MailIcon from 'assets/images/login/mail.svg'
import 'containers/sigin-in/SignIn.scss'
import { toast } from 'react-toastify'
import CustomToast from 'components/common/custom-toast/CustomToast'
import { alertTypes } from 'constants/Common'

function ForgotPasswordForm() {
  const submitHandler = async (values, setErrors, setSubmitting) => {
    setSubmitting(true)
    try {
      const result = await forgetUserPassword(values, setErrors)
      if (result?.status === 200) {
        setSubmitting(false)
        toast(
          <CustomToast
            variant={alertTypes.SUCCESS}
            message={result?.statusText || 'SignIn Successfully!'}
          />
        )
      } else {
        toast(
          <CustomToast
            variant={alertTypes.DANGER}
            message={result?.response?.data?.error}
          />
        )
      }
    } catch (e) {
      console.log('error is', e)
      toast(
        <CustomToast variant={alertTypes.DANGER} message={e?.data?.error} />
      )
    } finally {
      setSubmitting(false)
    }
  }
  return (
    <div className='login-card'>
      <div className='login-card-header'>
        <img className='login-logo' src={Logo} width={175} height={50} alt='XLR8' />
        <div className='login-card-copy'>
          <h1>Forgot password</h1>
          <p>Enter your email to reset your password.</p>
        </div>
      </div>
      <div className='login-divider' />
      <Formik
        initialValues={forgotInitialValues}
        validationSchema={forgotPasswordSchema}
        onSubmit={(values, { setErrors, setSubmitting }) => {
          submitHandler(values, setErrors, setSubmitting)
        }}
      >
        <Form className='login-form'>
          <div className='login-field'>
            <label htmlFor='forgot-email'>
              Email Address<span>*</span>
            </label>
            <div className='login-input'>
              <img src={MailIcon} width={20} height={20} alt='' />
              <Field
                id='forgot-email'
                type='email'
                name='email'
                placeholder='hello@Ascend.com'
              />
            </div>
            <ErrorMessage
              name='email'
              component='p'
              className='error-message'
            />
          </div>
          <button type='submit' className='login-submit'>
            Forgot Password
          </button>
        </Form>
      </Formik>
    </div>
  )
}

export default ForgotPasswordForm
